import convertToQuestion from './convertToQuestion'

function parseQuestions(responseQuestions): ComplianceQuestion[] {
  const questions = Object.keys(responseQuestions)

  return questions.map((questionId, index) => ({
    ...convertToQuestion(questionId, responseQuestions[questionId], index),
    total: questions.length
  }))
}

export default parseQuestions
